module.exports = __webpack_public_path__ + "ameliaG2.png?7a55761fb6f74300a4b62a5aeb2965a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/ameliaG2.png
// module id = 87
// module chunks = 0